import { Routes } from '@angular/router';
import { ERROR_PAGES_ROUTES } from '@smartera/components';

export const routes: Routes = [
	{
		path: '',
		redirectTo: '/login',
		pathMatch: 'full',
	},
	{
		path: 'short-access',
		loadChildren: () => import('@modules/short-access/short-access.module').then((m) => m.ShortAccessModule),
	},
	{
		path: 'error',
		children: ERROR_PAGES_ROUTES,
	},
];
